import { makeStyles } from '@material-ui/core'
import { Grid, Tooltip, Zoom } from '@mui/material'
import formatDate from 'src/utils/commonMethods/formatDate'
import policyDuration from 'src/assets/PolicyTile_Images/policyDuration.svg'
import {
  daysCalculator,
  isCorporatePOC,
  isMotorInsurance,
} from 'src/utils/commonMethods'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import DefaultLogo from 'src/assets/PolicyDetails_Images/DefaultLogo.svg'
import {
  CLIENT_TYPE,
  INSURANCE_CATEGORIES,
  POLICY_STATUS_TYPE_ENUMS,
  POLICY_STATUS_TYPES,
} from 'src/utils/constants/common'
import { useHistory } from 'react-router-dom'
import { getBuyType } from 'src/utils/commonMethods/buyPolicy'
import { INSURANCE_NAMES } from 'src/utils/constants/InsuranceNames'
import RenewNow from 'src/assets/PolicyTile_Images/RenewNow.svg'
import { useState } from 'react'
import Modal from 'src/components/common/Modal'
import RenewModal from 'src/components/common/RenewPolicy/RenewModal'
import TrackRenewedPolicyForm from 'src/components/common/RenewPolicy/TrackRenewedPolicyForm'
import RenewedPolicy from 'src/assets/PolicyTile_Images/RenewedPolicy.svg'
import { useDispatch, useSelector } from 'react-redux'
import { updateBuyPolicyTitle } from 'src/actions'

const PolicyTile = ({ policyDetails, handlePolicySelect, clientType }) => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  const numberOfDayForExpiryDate = daysCalculator(policyDetails?.expiresOn)

  const [showRenewalModal, setShowRenewalModal] = useState(false)
  const [showTrackForm, setShowTrackForm] = useState(false)
  const [isTracking, setIsTracking] = useState(false)
  const [trackClick, setTrackClick] = useState(false)
  const userInfo = useSelector((state) => state?.userInfo)
  const role = userInfo?.userInfo?.userData?.roles

  const showExpiryStatus = () => {
    return (
      (numberOfDayForExpiryDate < 0 && numberOfDayForExpiryDate > -30) ||
      policyDetails?.status === POLICY_STATUS_TYPES?.expired
    )
  }

  const getExpiryText = () => {
    return numberOfDayForExpiryDate < 0 && numberOfDayForExpiryDate > -30
      ? POLICY_STATUS_TYPE_ENUMS?.EXPIRING
      : POLICY_STATUS_TYPE_ENUMS[policyDetails?.status]
  }

  const getExpiryDaysText = () => {
    return numberOfDayForExpiryDate < 0 && numberOfDayForExpiryDate > -30
      ? `In ${Math.abs(numberOfDayForExpiryDate)} days`
      : `${Math.abs(numberOfDayForExpiryDate)} days back`
  }

  const handleClick = () => {
    const insuranceType =
      policyDetails?.insuranceType === INSURANCE_NAMES?.MOTOR_INSURANCE
        ? policyDetails?.productSubType
        : policyDetails?.insuranceType
    const url = getBuyType(insuranceType)

    if (
      url !== INSURANCE_CATEGORIES?.HEALTH &&
      url !== INSURANCE_CATEGORIES?.BIKE &&
      url !== INSURANCE_CATEGORIES?.MOTOR
    ) {
      dispatch(updateBuyPolicyTitle(insuranceType))
      history.push('/individual/dashboard/buyPolicy/life')
    } else {
      history.push(`/individual/dashboard/buyPolicy/${url}`)
    }
  }

  const handleUploadRenewalModal = () => {
    setShowRenewalModal(true)
  }

  const closeRenewalModal = () => {
    setShowRenewalModal(false)
  }

  const handleTrackClick = (isTrack) => {
    setShowTrackForm(true)
    setIsTracking(isTrack)
    setTrackClick(isTrack)
  }

  const closeTrackModalForm = () => {
    setShowTrackForm(false)
  }

  return (
    <>
      {showRenewalModal ? (
        <Modal
          id='modal'
          bgcolor={'#FFF'}
          ordered={showRenewalModal}
          width={'30%'}
          left={'32%'}
          top={'30%'}
          borderRadius={'10px'}
          modelClosed={closeRenewalModal}
        >
          <RenewModal
            closeRenewModal={closeRenewalModal}
            policyDetails={policyDetails}
            handleClick={handleClick}
          />
        </Modal>
      ) : null}
      {showTrackForm ? (
        <Modal
          id='modal'
          bgcolor={'#FFF'}
          ordered={showTrackForm}
          width={'90%'}
          left={'5%'}
          top={'7%'}
          borderRadius={'10px'}
          modelClosed={closeTrackModalForm}
        >
          <TrackRenewedPolicyForm
            closeModal={closeTrackModalForm}
            policyData={policyDetails}
            isTracking={isTracking}
            trackClick={trackClick}
            clientType={clientType}
          />
        </Modal>
      ) : null}
      <div className={classes.mainContainer}>
        <div className={classes.tileContainer} onClick={handlePolicySelect}>
          <div className={classes.headingContainer}>
            <div className={classes.heading}>
              <div>
                <img
                  src={policyDetails?.productImage ?? DefaultLogo}
                  className={classes.providerImage}
                  alt='Logo'
                />
              </div>
              <div>
                <Tooltip
                  TransitionComponent={Zoom}
                  placement='top'
                  title={policyDetails?.insuranceType}
                  arrow
                >
                  <div className={classes.providerName}>
                    <span>{policyDetails?.insuranceType} :</span>
                  </div>
                </Tooltip>
                <div>
                  <span className={classes.policyNumberText}>
                    Policy No: {policyDetails?.policyNumber}
                  </span>
                </div>
                <Tooltip
                  TransitionComponent={Zoom}
                  title={policyDetails?.id}
                  arrow
                >
                  <div className={classes.policyNumberContent}>
                    <span className={classes.policyNumberText}>
                      Policy Id: {policyDetails?.id}
                    </span>
                  </div>
                </Tooltip>
              </div>
            </div>
            <div className={classes.headingDate}>
              {policyDetails?.status === POLICY_STATUS_TYPES?.expired && (
                <span className={classes.expired}>Expired</span>
              )}
              {policyDetails?.status === POLICY_STATUS_TYPES?.renewed && (
                <span className={classes.expired}>Renewed</span>
              )}
              <div className={classes.dateImageContent}>
                <div className={classes.dateImage}>
                  <img
                    src={policyDuration}
                    alt='datePicker'
                    className={classes.datePickerImage}
                  />
                </div>
                <div className={classes.dateContent}>
                  <div>
                    <span className={classes.date}>
                      {formatDate(policyDetails?.issuedOn)}&nbsp;
                    </span>
                  </div>
                  <div className={classes.date}>
                    <span className={classes.date}>
                      {formatDate(policyDetails?.expiresOn)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.contentContainer}>
            <Grid
              container
              direction={'row'}
              alignItems={'stretch'}
              justifyContent={'center'}
            >
              {isMotorInsurance(policyDetails?.insuranceType) && (
                <Grid item xs={12} sm={6} md={3} lg={4} xl={3}>
                  <div className={classes.content}>
                    <div className={classes.textContentModel}>
                      <span>
                        {policyDetails?.otherInformation?.vehicleMakeModel ??
                          '-'}
                      </span>
                    </div>
                    <div className={classes.textContentNumber}>
                      <span>
                        {policyDetails?.otherInformation?.vehicleNumber ?? '-'}
                      </span>
                    </div>
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={3} lg={4} xl={3}>
                <div className={classes.content}>
                  <div className={classes.textContent}>
                    <span>Total Premium Paid</span>
                  </div>
                  <div className={classes.textValue}>
                    <span>
                      {formatToINR(policyDetails?.premiumAmount?.text)}
                    </span>
                  </div>
                </div>
              </Grid>
              {isMotorInsurance(policyDetails?.insuranceType) ? (
                <Grid item xs={12} sm={6} md={3} lg={4} xl={3}>
                  <div className={classes.content}>
                    <div className={classes.textContent}>IDV</div>

                    <Tooltip
                      title={
                        policyDetails?.otherInformation?.vehicleIdv
                          ? formatToINR(
                              policyDetails?.otherInformation?.vehicleIdv
                            )
                          : '-'
                      }
                    >
                      <div className={classes.textValue}>
                        <span>
                          {policyDetails?.otherInformation?.vehicleIdv
                            ? formatToINR(
                                policyDetails?.otherInformation?.vehicleIdv
                              )
                            : '-'}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12} sm={6} md={3} lg={4} xl={3}>
                  <div className={classes.content}>
                    <div className={classes.textContent}>Sum Insured</div>

                    <Tooltip
                      title={formatToINR(
                        policyDetails?.sumAssured?.text ?? '-'
                      )}
                    >
                      <div className={classes.textValue}>
                        <span>
                          {formatToINR(policyDetails?.sumAssured?.text ?? '-')}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </Grid>
              )}

              {showExpiryStatus() ? (
                <Grid item xs={12} sm={6} md={3} lg={4} xl={3}>
                  <div className={classes.content}>
                    <div className={classes.textContentExpired}>
                      <span>{getExpiryText()}</span>
                    </div>
                    <div className={classes.textContentExpiredText}>
                      <span>{getExpiryDaysText()}</span>
                    </div>
                  </div>
                </Grid>
              ) : null}
            </Grid>
          </div>
        </div>
      </div>
      {(isCorporatePOC(role) ||
        policyDetails?.policyHolder?.type !== CLIENT_TYPE?.CORPORATE) &&
        (policyDetails?.status === POLICY_STATUS_TYPES?.expired ||
          (policyDetails?.isNearToExpire &&
            policyDetails?.status === POLICY_STATUS_TYPES?.active &&
            !policyDetails?.isCompanyPolicy)) && (
          <div className={classes.renewedPolicy}>
            <img
              src={RenewNow}
              alt='renewNowButton'
              className={classes.renewNowButton}
              onClick={() => handleUploadRenewalModal(false)}
            />
          </div>
        )}
      {(isCorporatePOC(role) ||
        policyDetails?.policyHolder?.type !== CLIENT_TYPE?.CORPORATE) &&
        policyDetails?.status === POLICY_STATUS_TYPES?.underRenewal &&
        !policyDetails?.isCompanyPolicy && (
          <div className={classes.renewedPolicyContainer}>
            <img
              src={RenewedPolicy}
              alt='renewedPolicyButton'
              className={classes.renewedPolicyButton}
            />
          </div>
        )}
      <div>
        {(isCorporatePOC(role) ||
          policyDetails?.policyHolder?.type !== CLIENT_TYPE?.CORPORATE) &&
          policyDetails?.status === POLICY_STATUS_TYPES?.renewed &&
          !policyDetails?.isCompanyPolicy && (
            <div className={classes.trackTile}>
              <span
                className={classes.trackTileTextHead}
                onClick={() => handleTrackClick(true)}
              >
                TRACK
              </span>
            </div>
          )}
      </div>
      <div>
        {(isCorporatePOC(role) ||
          policyDetails?.policyHolder?.type !== CLIENT_TYPE?.CORPORATE) &&
          policyDetails?.status === POLICY_STATUS_TYPES?.active &&
          policyDetails?.oldPolicyId &&
          !policyDetails?.isCompanyPolicy && (
            <div className={classes.trackTile}>
              <span
                className={classes.trackTileTextHead}
                onClick={() => handleTrackClick(true)}
              >
                TRACK
              </span>
            </div>
          )}
      </div>
    </>
  )
}

export default PolicyTile

const useStyles = makeStyles({
  mainContainer: {
    border: '1px solid #D4D4D4',
    borderRadius: '10px',
    height: '100%',
  },
  tileContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    cursor: 'pointer',
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 10px',
    flexWrap: 'wrap',
    height: '100%',
  },
  heading: {
    display: 'flex',
    padding: '10px',
    gap: '12px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
  },
  headingDate: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  headingIcons: {
    display: 'flex',
    padding: '10px',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  providerImageContainer: {
    minWidth: '30px',
    width: '10%',
  },
  providerImage: {
    width: '35px',
    height: '35px',
  },
  providerName: {
    fontSize: '14px',
    fontWeight: '600',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    '@media only screen and (max-width: 350px)': {
      maxWidth: '120px',
    },
    '@media only screen and (min-width: 1200px) and (max-width: 1440px)': {
      maxWidth: '180px',
    },
  },
  providerValueContent: {
    display: 'grid',
    background: '#E8E8E8',
    padding: '6px',
    borderRadius: '3px',
    minWidth: '30px',
    width: '40px',
  },
  providerValue: {
    fontSize: '18px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    color: '#B92250',
    justifyContent: 'center',
  },
  providerValueText: {
    fontSize: '9px',
    fontWeight: '400',
    color: '#595959',
    textAlign: 'center',
  },
  viewAll: {
    fontSize: '12px',
    color: '#B92250',
    fontWeight: '500',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  contentContainer: {
    display: 'flex',
    padding: '10px',
    background: '#F1EAED',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '0px 0px 10px 10px',
    height: '100%',
  },
  content: {
    // textAlign: 'center',
    padding: '0px 7px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentModel: {
    padding: '0px 7px',
  },
  textContent: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    display: 'flex',
    gap: '3px',
  },
  textContentModel: {
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '14px',
    display: 'flex',
    gap: '3px',
  },
  textContentNumber: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '21px',
    display: 'flex',
    gap: '3px',
  },
  textContentExpired: {
    color: '#E03333',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '22px',
    textTransform: 'capitalize',
  },
  textContentExpiredText: {
    color: '#E03333',
    fontSize: '11px',
    fontWeight: '400',
    lineHeight: '17px',
    display: 'flex',
  },
  textValue: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '21px',
    padding: '5px 0px 0px 0px',
  },
  policiesContent: {
    textAlign: 'initial',
  },
  policyStatusContainer: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    display: 'flex',
    gap: '3px',
    marginBottom: '5px',
    '&:hover': {
      color: '#B92250',
      padding: '5px',
      transform: 'translateX(0px) scale(1.25)',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer',
    },
  },
  statusCount: {
    color: '#D80027',
    fontSize: '13px',
    fontWeight: '700',
  },
  digitalizingCount: {
    color: '#1192CC',
    fontSize: '13px',
    fontWeight: '700',
  },
  dateImageContent: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
  },
  dateContent: {
    fontSize: '13px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
    flexWrap: 'wrap',
    justifyContent: 'spaceBetween',
  },
  date: {
    fontSize: '13px',
    color: '#333333',
  },
  datePickerImage: {
    width: '16px',
    height: '35px',
  },
  dateImage: {
    display: 'flex',
  },
  policyNumberText: {
    fontSize: '12px',
    // color: 'rgba(26, 26, 26, 0.6)',
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    fontWeight: '400',
  },
  renewContent: {
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '14px',
    color: '#FFFFFF',
    textAlign: 'center',
    padding: '3px 15px',
    background: '#E03333',
    border: '2px solid #E03333',
    borderRadius: '10px',
  },
  renewContainer: {
    position: 'relative',
    marginTop: '-12px',
    textAlign: 'right',
    justifyContent: 'flex-end',
    marginRight: '15px',
    cursor: 'pointer',
  },
  gridContainer: {
    display: 'flex !important',
    justifyContent: 'space-between',
  },
  renewNowButton: {
    width: '100px',
  },
  renewedPolicy: {
    padding: '0px 5px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  renewedPolicyButton: {
    width: '250px',
  },
  trackTile: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '-9px',
  },
  trackTileTextHead: {
    color: '#B92250',
    padding: '10px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '14px',
    letterSpacing: '0em',
    textDecoration: 'underline',
  },
  renewedPolicyContainer: {
    padding: '0px 5px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  expired: {
    fontSize: '9px',
    border: '1px solid rgba(239, 96, 96, 1)',
    borderRadius: '64px',
    color: 'rgba(255, 255, 255, 1)',
    lineHeight: '11px',
    background: 'rgba(239, 96, 96, 1)',
    textTransform: 'uppercase',
    padding: '3px',
  },
})
